import { useState } from "react";

export default function Faq() {
  const faqs = [
    {
      q: "How do I become a member of the XAO DAO?",
      a: "You become a member by minting a Membership NFT on the XRP Ledger. This NFT represents your rights in governance and confirms your membership. The process involves paying a small one-time membership fee (currently $10 USD equivalent in XRP)\nOnce the NFT is in your wallet, you’re officially recognized as a member and can participate in proposals, voting, and other DAO activities."
    },
    {
      q: "Why do I need to sign something on an EVM sidechain?",
      a: "Some parts of membership management and smart contract execution take place on an EVM-compatible sidechain. This gives the DAO flexibility to integrate with tools, reduce transaction costs, and ensure scalability. Signing on the sidechain is just a way of linking your wallet to the DAO’s systems so your membership is properly recorded and verifiable."
    },
    {
      q: "Do I have to link a social account (Google, Apple, Meta) to register?",
      a: "No. Membership is based on your XRP wallet and the Membership NFT, not social accounts. You can choose to connect a social account if you want easier login, notifications, or recovery options, but it is completely optional."
    },
    {
      q: "What is the purpose of the Membership NFT?",
      a: "The Membership NFT is your digital proof of membership. It gives you rights to:\n- Vote on governance proposals\n- Submit new proposals\n- Share in potential profits or treasury distributions (if approved by the community)\nUnlike regular NFTs, this one is non-transferable except in specific cases allowed by the Operating Agreement. This ensures membership stays tied to real participants, not speculators."
    },
    {
      q: "Will my personal information be stored or shared?",
      a: "- For general membership: No personal information is required. The DAO only records your wallet address and Membership NFT on the blockchain.\n- For profit distributions: If the DAO distributes profits, you may need to provide personal details for tax compliance. For example, U.S. members must provide information for the IRS so a K-1 form can be issued. Members in other countries may need to provide the details required by their own tax authorities.\n- If you choose not to provide this information, your share of distributions will remain in the XAO DAO treasury until such time as you provide the necessary details.\n\nThe DAO does not sell or share personal data. It is only collected if legally required for financial distributions."
    },
    {
      q: "Can I submit a proposal without being a member?",
      a: "No. Only verified members holding a Membership NFT can submit proposals. This prevents spam and ensures that only committed participants influence governance decisions. However, non-members can still share ideas with the community, which a member may choose to sponsor as a formal proposal."
    },
    {
      q: "What if I lose access to my XRP wallet?",
      a: "If you lose access to your wallet (for example, by losing private keys), you can request a membership recovery:\n1. Notify the DAO managers within 30 days.\n2. Provide proof of ownership of the lost wallet (if possible).\n3. Mint a new Membership NFT in a different wallet.\nThe lost NFT will then be revoked, and your membership rights moved to the new wallet.\n\nPlease note: governance and voting rights are always tied to the wallet holding the NFT, so until recovery is complete, the old wallet will still show as a member."
    }
  ];

  const [openIndices, setOpenIndices] = useState(new Set());

  const toggleFaq = (idx) => {
    setOpenIndices((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(idx)) {
        newSet.delete(idx);
      } else {
        newSet.add(idx);
      }
      return newSet;
    });
  };

  return (
    <section
    id="faq"
      className="relative w-screen min-h-screen py-20 flex flex-col items-center overflow-hidden"
      style={{
        background:
          "linear-gradient(#FFFFFF 0%, rgba(255,255,255,0) 90%), " +
          "linear-gradient(rgba(103,119,255,0.09) 10%, rgba(195,131,251,0.09) 100%)"
      }}
    >
      <div
        className="absolute top-0 left-0 w-full h-full -z-10"
        style={{ backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
      />
      <div className="max-w-6xl w-full mx-auto px-4">
        <h2 className="text-5xl font-medium text-[#121828] text-center mb-8">New to XAO DAO? Start here.</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-lg p-6 cursor-pointer" onClick={() => toggleFaq(idx)}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-semibold text-[#121828] text-lg">{faq.q}</span>
                <img src="./downArrow.png" alt="arrow" className={`transition-all duration-200 w-3 h-3 ${openIndices.has(idx) ? 'rotate-90' : ''}`} />
              </div>
              {openIndices.has(idx) && (
                <div
                  className="text-[#414653] text-base mt-2"
                  dangerouslySetInnerHTML={{ __html: faq.a.replace(/\n/g, '<br />') }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}